/** Display labels for the caregiver `Gender` enum. Single source of truth for
 *  the portal + admin (mirrors `credential-labels.ts`). Kept here so a wording /
 *  i18n change ships without touching every consumer. */
export const GENDER_LABELS = {
    FEMALE: 'Female',
    MALE: 'Male',
    NON_BINARY: 'Non-binary',
    PREFER_NOT_TO_SAY: 'Prefer not to say',
};
/** Human label for a gender value, with an em-dash fallback for null/undefined
 *  (a pre-existing caregiver from before the field shipped). */
export function genderLabel(gender) {
    return gender ? GENDER_LABELS[gender] : '—';
}
//# sourceMappingURL=gender-labels.js.map